import { Component, Inject, OnInit } from '@angular/core';
import { OrganizationServices } from '../../services/organization.services';
import _ from 'lodash';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-town-dialog',
  templateUrl: './town-dialog.component.html',
  styleUrls: ['./town-dialog.component.scss']
})
export class TownDialogComponent implements OnInit {
  organizations: any;
  townName: any;

  loading: any = false;
  
  constructor(private organizationService: OrganizationServices, @Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<TownDialogComponent>, private router: Router) { 
    this.getOrganizations();
  }

  ngOnInit() {
  }
  getOrganizations() {
    this.loading = true;
    this.organizationService.getOrganizationList()
      .subscribe(data => {
          this.organizations = data;
          this.loading = false;
        });
  }

  closeDialog(){
    this.dialogRef.close();
  }

  navigate(townName) {
    localStorage.setItem('town', townName);
    this.closeDialog();
    this.router.navigate(['cases', 'form', this.data]);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/town-dialog/town-dialog.component.ts